module.exports = __webpack_public_path__ + "media/images/icons/expand-right-b8f77a1d90631fdbb7d7eea5d3e19526.svg";